<template>
  <div class="h-full min-h-0 w-full flex-1 overflow-y-auto scrollbar-light">
    <!-- Shared by loading, empty, and error states; tall content stays reachable from the top. -->
    <div class="flex min-h-full flex-col px-4 py-6 sm:py-8">
      <div class="my-auto w-full shrink-0">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
  provide('emptyStateCentered', true);
</script>
